import { render } from "./AddNewPurchase.vue?vue&type=template&id=49b9c9a2&scoped=true"
import script from "./AddNewPurchase.vue?vue&type=script&lang=js"
export * from "./AddNewPurchase.vue?vue&type=script&lang=js"

import "./AddNewPurchase.vue?vue&type=style&index=0&id=49b9c9a2&lang=scss&scoped=true"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b9c9a2"]])

export default __exports__